import { Marker, useMapEvents } from 'react-leaflet';
import React, { forwardRef, ForwardRefRenderFunction, useEffect, useImperativeHandle, useState } from 'react';
import L, { LatLngLiteral } from 'leaflet';
import mapService, { BAMarkerResult } from 'services/api/businessService/mapService';

export enum MarkerType {
	DIEM_CHAY,
	CO_SO_CONG_TRINH,
	DON_VI_HO_TRO,
	DIEM_LAY_NUOC,
	DON_VI_PCCC,
}

interface ToaDoMarkerProps {
	center?: LatLngLiteral;
	markerType?: MarkerType;
	toado?: { kinhDo: number; viDo: number };
	clickCallback(arg: BAMarkerResult): void;
	onCoordinateSelect?: (lat: number, lng: number) => void;
}

export interface ToaDoMarkerRef {
	setMarkerPosition: (newPos: LatLngLiteral) => void;
}

const ToaDoMarker: ForwardRefRenderFunction<any, ToaDoMarkerProps> = (props, ref) => {
	const [markerPosition, setMarkerPosition] = useState<LatLngLiteral | undefined>(props.center);
	const [toaDo, setToaDo] = useState<any>();

	const syncMarkerPosition = (lat?: number, lng?: number) => {
		if (typeof lat === 'number' && typeof lng === 'number' && !Number.isNaN(lat) && !Number.isNaN(lng)) {
			setMarkerPosition({ lat, lng });
			setToaDo({ kinhDo: lng, viDo: lat });
		}
	};

	useEffect(() => {
		if (
			(typeof props.toado?.viDo === 'number' || typeof props.toado?.kinhDo === 'number') &&
			(!toaDo || props.toado?.kinhDo !== toaDo.kinhDo || props.toado?.viDo !== toaDo.viDo)
		) {
			syncMarkerPosition(props.toado?.viDo, props.toado?.kinhDo);
			mapService.reverseGeocode(props.toado?.viDo, props.toado?.kinhDo).then(props.clickCallback);
		}
	}, [props.toado?.kinhDo, props.toado?.viDo]);

	useImperativeHandle(ref, () => ({
		setMarkerPosition(newPos: LatLngLiteral) {
			setMarkerPosition(newPos);
		},
	}));

	// Click Map event handler
	useMapEvents({
		click(e: any) {
			const { lat, lng } = e.latlng;
			syncMarkerPosition(lat, lng);
			props.onCoordinateSelect?.(lat, lng);
			mapService.reverseGeocode(lat, lng).then(props.clickCallback);
		},
	});

	// set icon for map
	const setIconForMap = () => {
		switch (props.markerType) {
			case MarkerType.CO_SO_CONG_TRINH:
				return 'icon/map/construction.svg';
			case MarkerType.DIEM_CHAY:
				return 'icon/map/firing.svg';
			case MarkerType.DIEM_LAY_NUOC:
				return 'icon/map/fireHydrant.svg';
			case MarkerType.DON_VI_HO_TRO:
				return 'icon/map/support-inActive.svg';
			case MarkerType.DON_VI_PCCC:
				return 'icon/map/fireStation.svg';
			default:
				return 'icon/map/firing.svg';
		}
	};

	return markerPosition ? (
		<Marker
			icon={L.icon({
				iconUrl: setIconForMap(),
				iconSize: [32, 32],
				iconAnchor: [24, 48],
			})}
			key={`${markerPosition.lat}-${markerPosition.lng}`}
			position={[markerPosition.lat, markerPosition.lng]}
		/>
	) : null;
};

export default forwardRef(ToaDoMarker);
